<template>
  <div class="text-center">
    <v-dialog
      v-model="$store.usersStore.state.newUserModal"
      max-width="640"
			max-height="98vh"
      content-class="new-user-dialog"
      persistent
    >
      <v-card class="user-modal" elevation="0">

        <!-- Header -->
        <div class="modal-header">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon color="white" size="20">mdi-account-plus-outline</v-icon>
            </div>
            <div>
              <div class="modal-title">Creación de Usuario</div>
              <div class="modal-subtitle">Completa los datos para registrar un nuevo usuario</div>
            </div>
          </div>
          <v-btn icon small @click="closeModal" class="close-btn">
            <v-icon color="rgba(255,255,255,0.7)" size="18">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <v-form ref="form" v-model="validform" class="form-wrapper">
          <div class="scroll-area">

            <!-- Avatar -->
            <div class="avatar-section">
              <div class="avatar-preview" @click="triggerFileInput">
                <img v-if="avatarPreviewUrl" :src="avatarPreviewUrl" alt="avatar preview" />
                <v-icon v-else size="30" color="#b0bedd">mdi-account</v-icon>
                <div class="avatar-overlay">
                  <v-icon size="16" color="white">mdi-camera-outline</v-icon>
                </div>
              </div>
              <div class="avatar-info">
                <div class="avatar-label">Imagen de perfil</div>
                <div class="avatar-actions">
                  <button type="button" class="btn-link" @click="triggerFileInput">Seleccionar imagen</button>
                  <button v-if="newUserData.avatar" type="button" class="btn-link danger" @click="removeAvatar">Quitar</button>
                </div>
              </div>
              <input
                ref="avatarInput"
                type="file"
                accept=".png,.jpg,.jpeg"
                class="hidden-input"
                @change="onAvatarChange"
              />
            </div>

            <!-- Datos personales -->
            <div class="section-label">
              <v-icon size="13" color="#2D4B95" class="mr-1">mdi-account-outline</v-icon>
              Datos personales
            </div>
            <div class="field-grid">
              <div class="field-group span-2">
                <label class="field-label">Nombre</label>
                <v-text-field
                  v-model="newUserData.name"
                  placeholder="Ingrese nombre del usuario"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="requiredRule"
                  class="custom-field"
                ></v-text-field>
              </div>
              <div class="field-group">
                <label class="field-label">Email</label>
                <v-text-field
                  v-model="newUserData.email"
                  placeholder="correo@empresa.cl"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="emailRules"
                  class="custom-field"
                ></v-text-field>
              </div>
              <div class="field-group">
                <label class="field-label">Teléfono</label>
                <v-text-field
                  v-model="newUserData.phone"
                  placeholder="Ingrese teléfono del usuario"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="requiredRule"
                  class="custom-field"
                ></v-text-field>
              </div>
              <div class="field-group span-2">
                <label class="field-label">Dirección</label>
                <v-text-field
                  v-model="newUserData.address"
                  placeholder="Ingrese dirección del usuario"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="requiredRule"
                  class="custom-field"
                ></v-text-field>
              </div>
            </div>

            <!-- Empresa y proyecto -->
            <div class="section-label mt-5">
              <v-icon size="13" color="#2D4B95" class="mr-1">mdi-domain</v-icon>
              Empresa y proyecto
            </div>
            <div class="field-grid">
              <div class="field-group">
                <label class="field-label">Empresa</label>
                <div class="d-flex flex-row align-center company-row">
                  <v-select
                    v-model="newUserData.company_id"
                    :items="$store.userStore.state.userCompanies"
                    :loading="!$store.userStore.state.userInfo"
                    item-text="company.name"
                    item-value="company.id"
                    placeholder="Seleccione empresa"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="requiredRule"
                    class="custom-field flex-grow-1"
                  ></v-select>
                  <button
                    type="button"
                    class="icon-add-btn"
                    v-if="checkCompanyLevelPermissions(['create_company'])"
                    @click="$store.projectsStore.commit('setNewCompanyModal', true)"
                  >
                    <v-icon size="16" color="white">mdi-plus</v-icon>
                  </button>
                </div>
              </div>
              <div class="field-group">
                <label class="field-label">Proyecto</label>
                <v-select
                  v-model="newUserData.project_id"
                  :items="$store.projectsStore.state.projectsList"
                  :loading="!$store.projectsStore.state.projectsList"
                  item-text="name"
                  item-value="id"
                  placeholder="Asigne proyecto(s)"
                  outlined
                  dense
                  multiple
                  hide-details="auto"
                  :rules="requiredRule"
                  class="custom-field"
                ></v-select>
              </div>
              <div class="field-group span-2">
                <label class="field-label">Cargo por defecto</label>
                <v-select
                  v-model="newUserData.default_job"
                  :items="$store.usersStore.state.jobTypes"
                  item-text="name"
                  item-value="id"
                  placeholder="Seleccione cargo por defecto"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="requiredRule"
                  class="custom-field"
                ></v-select>
                <div class="field-hint">
                  <v-icon size="12" color="#8896b3" class="mr-1">mdi-information-outline</v-icon>
                  Al asignar a este usuario a un nuevo proyecto, se ingresará con este cargo si no seleccionas uno.
                </div>
              </div>
            </div>

          </div>

            <!-- Consentimiento (siempre visible, sobre los botones) -->
            <div class="consent-fixed">
              <div class="consent-highlight">
                <v-checkbox
                  v-model="newUserData.consent_declaration"
                  :rules="[v => !!v || 'Debes confirmar que el usuario fue informado antes de continuar']"
                  color="#2D4B95"
                  dense
                  hide-details
                >
                  <template v-slot:label>
                    <span class="consent-text">
                      Confirmo que el usuario ha sido debidamente informado sobre el tratamiento
                      de sus datos personales por parte de la empresa y que ha aceptado la
                      <a href="/privacidad" target="_blank" @click.stop>Política de Privacidad</a>
                      de LAOT, conforme al Art. 12 y 14 ter de la Ley 21.719.
                    </span>
                  </template>
                </v-checkbox>
              </div>
            </div>

          </v-form>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeModal">Cancelar</button>
          <button class="btn-save" :disabled="loadingData" @click="sendForm">
            <v-progress-circular v-if="loadingData" indeterminate size="15" width="2" color="white" class="mr-1"></v-progress-circular>
            <v-icon v-else size="15" color="white" class="mr-1">mdi-check</v-icon>
            Confirmar
          </button>
        </div>

      </v-card>
    </v-dialog>
    <AcceptCancelModal :acceptRejectModal="acceptRejectModal" :acceptRejectModalData="acceptRejectModalData"
      :closeModal="closeModalAcceptCancel"/>
  </div>
</template>

<script>
import {createUser, getUserByEmail} from '@/helpers/api/user'
import {getProjectsByUser} from '@/helpers/api/project'
import AcceptCancelModal from '@/components/Globals/Modals/General/AcceptCancelModal.vue'

export default {
  name: 'NewUserModal',
  components: { AcceptCancelModal },
  data: () => ({
    validform: true,
    newUserData: {
      name: null,
      email: null,
      phone: null,
      address: null,
      default_job: 2,
      avatar: null,
      company_id: null,
      project_id: null,
      consent_declaration: false,
    },
    avatarPreviewUrl: null,
    userCreated: null,
    acceptRejectModal: false,
    acceptRejectModalData: null,
    loadingData: false,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
    emailRules: [
      v => !!v || 'Email es obligatorio',
      v => /.+@.+\..+/.test(v) || 'Email debe ser válido',
    ],
  }),
  watch: {
    'newUserData.avatar'(file){
      if(this.avatarPreviewUrl){
        URL.revokeObjectURL(this.avatarPreviewUrl)
        this.avatarPreviewUrl = null
      }
      if(file){
        this.avatarPreviewUrl = URL.createObjectURL(file)
      }
    }
  },
  mounted(){
    const projectID = this.$store.projectsStore.state.selectedProject.id
    this.$store.usersStore.dispatch('jobTypesGet', projectID)
    if(!this.$store.projectsStore.state.projectsList){
      this.getProjectList()
    }
  },
  methods: {
    triggerFileInput(){
      this.$refs.avatarInput.click()
    },
    onAvatarChange(event){
      const file = event.target.files[0]
      if(file){
        this.newUserData.avatar = file
      }
      event.target.value = ''
    },
    removeAvatar(){
      this.newUserData.avatar = null
    },
    closeModal(){
      this.$store.usersStore.commit('setNewUserModal', false)
      this.newUserData = {
        name: null,
        email: null,
        phone: null,
        address: null,
        default_job: 2,
        avatar: null,
        company_id: null,
        project_id: null,
        consent_declaration: false,
      }
      this.validform = true
      this.loadingData = false
    },
    async getProjectList(){
      this.loading = true
      const projects = await getProjectsByUser()
      if(projects.code === 200){
        this.$store.projectsStore.commit('setProjectsList', projects.projects)
      }
      this.loading = false
    },
    async sendForm(){
      if(!this.newUserData.consent_declaration){
        const messageData = {
          message: 'Debes confirmar que el usuario fue informado antes de continuar',
          title: 'Error',
          type: 'danger',
          icon: 'mdi-close-octagon',
          color: '#F4516C',
        }
        this.setMessage(messageData)
        return
      }
      if(this.$refs.form.validate()){
        this.loadingData = true
        const formData = new FormData()
        let newUserData = {...this.newUserData}
        Object.keys(this.newUserData).forEach((key) => {
          if(newUserData[key]){
            if(key == 'project_id'){ newUserData[key] = JSON.stringify(newUserData[key]) }
            formData.append(key, newUserData[key])
          }
        })
        const user = await createUser(formData)
        if(user.code === 200){
          this.userCreated = user.user
          const data = {
            project_id: this.$store.projectsStore.state.selectedProject.id,
            start: 0,
            limit: 20
          }
          this.$store.usersStore.dispatch('getUsersList', data)
          const messageData = {
            message: 'Se ha creado correctamente el usuario',
            title: 'Usuario creado',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
          this.setMessage(messageData)
          this.closeModal()
        }
        else if(user.data){
          this.userCreated = user.user
          user.data.forEach(message => {
            const messageData = {
              message,
              title: 'Error',
              type: 'danger',
              icon: 'mdi-close-octagon',
              color: '#F4516C',
            }
            this.setMessage(messageData)
          })
          if( user.data.length == 1 && user.data[0].includes('Ese email ya está en uso') ){
            this.showAdduserToProjectAlert()
          }
        }
        this.loadingData = false
      }
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.globalStore.dispatch('addMessage', data)
    },
    showAdduserToProjectAlert(){
      this.acceptRejectModalData = {
        title: 'Agregar usuario a proyecto',
        content_a: 'El correo ya está en uso. ¿Deseas configurar los proyectos de este usuario?.'
      }
      this.acceptRejectModal = true
    },
    async closeModalAcceptCancel(status = false){
      this.acceptRejectModal = false
      this.acceptRejectModalData = null
      if(status){
        const user = await getUserByEmail({email: this.newUserData.email})
        this.closeModal()
        if(user.code == 200){
          this.editUserProjects(user.user)
        }
      }
    },
    editUserProjects(user){
      this.$store.usersStore.commit('setSelectedUserInfo', user)
      this.$store.usersStore.commit('setEditUserProjectsModal', true)
    },
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }

.user-modal {
  border-radius: 16px !important;
  overflow: hidden;
  background: #ffffff;
  display: flex !important;
  flex-direction: column !important;
  max-height: 98vh;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px 16px;
  background: linear-gradient(135deg, #2D4B95 0%, #1a2f63 100%);
  flex-shrink: 0;
}
.header-left { display: flex; align-items: center; gap: 12px; }
.header-icon-wrap {
  width: 36px; height: 36px; border-radius: 10px;
  background: rgba(255,255,255,0.15);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.modal-title { font-size: 14px; font-weight: 600; color: #fff; line-height: 1.2; }
.modal-subtitle { font-size: 11px; color: rgba(255,255,255,0.6); margin-top: 2px; }
.close-btn { background: rgba(255,255,255,0.1) !important; border-radius: 8px !important; }

.modal-body {
  padding: 0;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.form-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.scroll-area {
  overflow-y: auto;
  padding: 20px 22px 4px;
  flex: 1 1 auto;
  min-height: 0;
}
.consent-fixed {
  flex-shrink: 0;
  padding: 12px 22px 16px;
  border-top: 1px solid #e8edf5;
  background: #ffffff;
}

.section-label {
  font-size: 11px; font-weight: 600; color: #2D4B95;
  text-transform: uppercase; letter-spacing: 0.07em;
  display: flex; align-items: center; margin-bottom: 12px;
}

/* Avatar */
.avatar-section {
  display: flex; align-items: center; gap: 14px;
  padding: 14px 15px; border-radius: 12px;
  border: 1.5px solid #e2e8f4; background: #f7f9fc;
  margin-bottom: 20px;
}
.avatar-preview {
  position: relative; width: 60px; height: 60px; border-radius: 50%;
  background: #eef2fb; border: 1.5px solid #d1d9e8;
  display: flex; align-items: center; justify-content: center;
  overflow: hidden; cursor: pointer; flex-shrink: 0;
}
.avatar-preview img { width: 100%; height: 100%; object-fit: cover; }
.avatar-overlay {
  position: absolute; inset: 0; border-radius: 50%;
  background: rgba(26,47,99,0.45);
  display: flex; align-items: center; justify-content: center;
  opacity: 0; transition: opacity 0.15s;
}
.avatar-preview:hover .avatar-overlay { opacity: 1; }
.avatar-info { display: flex; flex-direction: column; gap: 4px; }
.avatar-label { font-size: 13px; font-weight: 600; color: #2d3748; }
.avatar-actions { display: flex; align-items: center; gap: 12px; }
.btn-link {
  background: none; border: none; padding: 0; cursor: pointer;
  font-size: 12px; font-weight: 600; color: #2D4B95;
}
.btn-link:hover { text-decoration: underline; }
.btn-link.danger { color: #F4516C; }
.hidden-input { display: none; }

/* Field grid */
.field-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 14px 16px; margin-bottom: 4px;
}
.field-group { display: flex; flex-direction: column; }
.field-group.span-2 { grid-column: span 2; }
.field-label {
  font-size: 12px; font-weight: 600; color: #5a6a8a;
  margin-bottom: 6px;
}
.field-hint {
  display: flex; align-items: flex-start;
  font-size: 11px; color: #8896b3; margin-top: 6px; line-height: 1.4;
}

.company-row { gap: 8px; }
.icon-add-btn {
  width: 40px; height: 40px; border-radius: 8px; border: none;
  background: linear-gradient(135deg, #2D4B95, #1a2f63);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; flex-shrink: 0; box-shadow: 0 2px 6px rgba(45,75,149,0.3);
}
.icon-add-btn:hover { filter: brightness(1.08); }

/deep/ .custom-field .v-input__slot { border-radius: 8px !important; min-height: 40px; }
/deep/ .custom-field.v-text-field--outlined fieldset { border-color: #e2e8f4; border-width: 1.5px; }
/deep/ .custom-field.v-text-field--outlined.v-input--is-focused fieldset { border-color: #2D4B95 !important; }
/deep/ .custom-field input, /deep/ .custom-field .v-select__selection { font-size: 13px; color: #2d3748; }
/deep/ .custom-field .v-text-field__slot input::placeholder { color: #a4b0c9; }
/deep/ .custom-field.error--text fieldset { border-color: #F4516C !important; }

/* Consent */
.consent-highlight {
  background: #eef2fb; border-radius: 8px;
  padding: 10px 13px; border: 1px solid rgba(45,75,149,0.25);
}
.consent-text { font-size: 12px; color: #5a6a8a; line-height: 1.55; }
.consent-text a { color: #2D4B95; font-weight: 600; }

/* Footer */
.modal-footer {
  display: flex; align-items: center; justify-content: flex-end;
  gap: 8px; padding: 13px 22px;
  border-top: 1px solid #e8edf5; background: #f7f9fc;
}
.btn-cancel {
  padding: 8px 16px; border-radius: 8px;
  border: 1.5px solid #d1d9e8; background: transparent;
  font-size: 13px; font-weight: 500; color: #5a6a8a; cursor: pointer;
}
.btn-cancel:hover { background: #eef2fb; border-color: #b0bedd; }
.btn-save {
  display: flex; align-items: center;
  padding: 8px 18px; border-radius: 8px; border: none;
  background: linear-gradient(135deg, #2D4B95, #1a2f63);
  font-size: 13px; font-weight: 600; color: white;
  cursor: pointer; box-shadow: 0 3px 10px rgba(45,75,149,0.3);
}
.btn-save:hover:not(:disabled) { box-shadow: 0 5px 14px rgba(45,75,149,0.4); }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; box-shadow: none; }

@media (max-width: 600px) {
  .field-grid { grid-template-columns: 1fr; }
  .field-group.span-2 { grid-column: span 1; }
}
</style>

<style>
/* v-dialog aplica max-height: 90% por defecto (teleportado fuera del scope del componente) */
.new-user-dialog.v-dialog {
  max-height: 98vh;
}
</style>